module.exports = __webpack_public_path__ + "img/a6d1d86.png";